import { useEffect, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';

export const useIsMobile = () => {
  const theme = useContext(ThemeContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () =>
      setIsMobile(
        window.innerWidth < Number(theme?.breakpoints?.sm?.replace(/\D/g, '')),
      );

    checkIfMobile();

    window.addEventListener('resize', checkIfMobile, { passive: true });
    return () => window.removeEventListener('resize', checkIfMobile);
  }, [theme.breakpoints.sm]);

  return isMobile;
};
